import ACTIONS from "../constants/actions";

const { GET_USER_QR_CODE } = ACTIONS;

const initialState = {
  qrCode: "",
};

const qrCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_QR_CODE:
      return {
        ...state,
        qrCode: action.payload.qrCode,
      };
    default:
      return state;
  }
};

export default qrCodeReducer;
